<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div class="row mb-4">
      <div class="col-sm-12 mb-4">
        <div class="card text-left">
          <div class="card-header">
            <div class="row" style="padding: inherit" v-if="!isMedico">
              <div class="col-sm-8">
                <button
                  class="btn th-custom-color mr-4"
                  type="button"
                  @click="regresarIndexDoctor()"
                  :disabled="this.user.tipo_user_orden_trabajo === 2 ? false : true"
                >
                  Regresar
                </button>
                <img
                  v-if="doctorInfo.imagen"
                  style="border-radius: 120px; height: 50px;margin-right: 6px;"
                  :src="doctorInfo.imagen"
                >
                  <strong style="font-size: 15px;">
                    {{ doctorInfo.nombre }}
                  </strong>
              </div>
              <div class="col-sm-4 text-right d-flex align-items-center justify-content-end">
                <input type="text" class="form-control mr-2"
                  v-model="busqueda"
                  autocomplete="off"
                  placeholder="Buscar"
                  style="max-width: 220px;"
                  @keyup="filtrarBusqueda">
                   <label class="switch switch-success mr-3">
                  <input type="checkbox" id="filter"
                    :checked="estado"
                    v-model="estado"
                    @change="getData">
                  <span class="slider"></span>
                  <span>{{ labelActivos }}</span>
                </label>
                <button class="btn w-auto px-3 btn-success">Para Hoy</button>
              </div>
            </div>
            <div class="row" v-else>
              <div class="d-flex p-2 background-title">
                <div class="font-weight-bold text-danger">
                    <p class="text-center">
                      El usuario no tiene vinculado un medico
                    </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-12 px-0">
              <OrdenItemDoctor
                :listaPacientes="listaPacientes"
                :medico_id="medico_id"
                :grupal="grupal"
              />
            </div>
            <div class="row">
              <div class="col-sm-8">
                </div>
              <div class="col-sm-4">
                <b-pagination
                  v-model="paginaActual"
                  :total-rows="totalFilas"
                  :per-page="porPagina"
                  class="my-0 float-right"
                  @input="getData"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';
import { mapState } from 'vuex';
import OrdenItemDoctor from '../components/OrdenItemDoctor.vue';

export default {
  name: 'index',
  components: {
    OrdenItemDoctor,
  },
  data() {
    return {
      busqueda: null,
      delayTimeout: null,
      estado: true,
      paginaActual: 1,
      totalFilas: 0,
      porPagina: 24,
      listaPacientes: [],
      medico_id: null,
      doctorInfo: {
        nombre: 'Doctor',
        imagen: null,
      },
      isLoading: true,
      isMedico: false,
      grupal: null,
    };
  },
  async created() {
    this.medico_id = this.decrypt(this.$route.params.id);
    await this.getData();
  },
  methods: {
    async getData() {
      const MEDICO_ID = atob(this.$route.params.id);
      try {
        if (MEDICO_ID !== 'null') {
          const REQUEST = {
            page: this.paginaActual,
            per_page: this.porPagina,
            estado: this.estado,
            filter_key: this.busqueda,
            medico_id: this.medico_id,
          };
          const RESPONSE = await axios.get('/clinic/orden_trabajo/patient', {
            params: REQUEST,
          });

          this.listaPacientes = RESPONSE.data.data.data;
          this.totalFilas = RESPONSE.data.data.total;
          this.grupal = RESPONSE.data.data.grupal;

          // Extraer información del médico
          if (RESPONSE.data.data.medico) {
            this.doctorInfo.nombre = RESPONSE.data.data.medico.nombre;
            this.doctorInfo.imagen = RESPONSE.data.data.medico.logo_perfil;
          }
        } else {
          this.isMedico = true;
        }
      } catch (error) {
        console.error('Error al cargar pacientes:', error);
        util.showNotify(error.response?.data?.message || 'Error al cargar los datos', 'error');
      } finally {
        this.isLoading = false;
      }
    },
    filtrarBusqueda() {
      const DELAY = 400;
      clearTimeout(this.delayTimeout);
      this.delayTimeout = setTimeout(this.getData, DELAY);
    },
    regresarIndexDoctor() {
      this.$router.push({ name: 'orden-trabajo-index' });
    },
    gotToOrden() {
      this.$router.push({ name: 'orden-trabajo-form1', params: { id: this.encrypt(1) } });
    },
    goToForm1(id) {
      this.$router.push({ name: 'orden-trabajo-medico', params: { id: this.encrypt(id) } });
    },
    encrypt(id) {
      return btoa(id);
    },
    decrypt(encodedId) {
      try {
        return atob(encodedId);
      } catch (error) {
        console.error('Error al desencriptar ID:', error);
        return null;
      }
    },
  },
  computed: {
    labelActivos() {
      if (this.estado) {
        return 'Activos';
      }
      return 'Inactivos';
    },
    ...mapState('main', [
      'user',
    ]),
  },
};
</script>

<style scoped>
.custom-top-padding {
  padding-top: 5.53px;
}
</style>
